export default __webpack_public_path__ + "b11d39247dbe3cbbaecb2233822f1a5b.png";